import { isValidURL } from "@/util/common";
import { isEmpty } from "lodash";
import {
	useNavigate,
	useLocation,
	useParams,
	NavigateOptions,
} from "react-router-dom";

const useRouter = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const params = useParams();

	const customNavigate = (url: string, params: NavigateOptions = {}) => {
		console.log(
			`The current URL is ${url} ${location.pathname} ${location.search} ${location.hash}`
		);
		console.log("params", params);
		if (!isEmpty(url)) {
			navigate(url, params); // 将 params 作为状态对象传递
		}
	};
	const goBack = (page?: string) => {
		if (page) {
			navigate(page, { replace: true });
		} else if (window.history.length > 1) {
			navigate(-1);
		} else {
			navigate("/game", { replace: true });
		}
	};
	const toExternalLink = (url: string) => {
		if (!isValidURL(url)) {
			// return Toast.show({
			// 	content: "当前链接不合法",
			// 	position: "top",
			// });
			return;
		}
		window.location.href = url;
	};

	return {
		customNavigate,
		location,
		params,
		goBack,
		toExternalLink,
	};
};

export default useRouter;
